"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPageLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _formPageLayoutModule = _interopRequireDefault(require("./form-page-layout.module.scss"));
var _Link = require("../../elements/link/Link");
var FormPageLayout = function FormPageLayout(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    children = _ref.children,
    title = _ref.title,
    discardRoute = _ref.discardRoute;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, breadcrumbs), /*#__PURE__*/_react.default.createElement("div", {
    className: _formPageLayoutModule.default['form-page-layout__header']
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: _formPageLayoutModule.default['form-page-layout__title']
  }, title), discardRoute && /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: discardRoute,
    className: _formPageLayoutModule.default['form-page-layout__link']
  }, t('formPageLayout.discard'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _formPageLayoutModule.default['form-page-layout__content']
  }, children));
};
exports.FormPageLayout = FormPageLayout;